export const ROOM_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ';
export const ROOM_CODE_LENGTH = 4;
export const MIN_PLAYERS = 2;
export const MAX_PLAYERS = 12;

/** The emoji a player can pick on the join screen; the server accepts only these. */
export const PARTY_EMOJI = [
  '🎤', '🎸', '🎧', '🪩', '🔥', '⭐', '🚀', '👑', '🦄', '🐙', '🦖', '🐸',
  '🍕', '🌮', '🍩', '🧃', '😎', '🤠', '👽', '🤖', '🎃', '🌈', '💃', '🕺',
] as const;

export const TIMINGS = {
  spinMs: 3500,
  answerMs: 25000,
  markMs: 10000,
  standingsMs: 4000,
  bangerMs: 8000,
  betweenMs: 8000,
};

export type Timings = typeof TIMINGS;

export const CONTACT_COPY =
  'Hosting with Spotify is invite-only. Contact josh@wafflehacker.dev to be added to the Spotify app.';
/** Shown when the host picks Spotify, before they log in. */
export const SPOTIFY_INVITE_COPY = CONTACT_COPY;

export function isRoomCode(code: string): boolean {
  if (code.length !== ROOM_CODE_LENGTH) return false;
  for (const ch of code) if (!ROOM_CODE_ALPHABET.includes(ch)) return false;
  return true;
}
